import { useUnit } from 'effector-react';
import { Button, ButtonType } from '@nx-frontend/shared/ui/button';
import { closeModalEvent } from '@nx-frontend/shared/ui/modal';

export function AutomationLimitLTDPopup() {
  const closeModal = useUnit(closeModalEvent);

  const onSubmit = () => {
    window.open('https://share.hsforms.com/1GU-hPq0aRq-Xkz9ftUXt2wcsi4h');
    closeModal();
  };

  return (
    <div className="flex flex-col text-center">
      <div className="mb-4 rounded-md">
        <img src="/assets/img/automation-limit-ltd.png" alt="" width="541" height="299" />
      </div>
      <h2 className="font-semibold mb-2 text-[24px] text-left">Unlock the power of automation now!</h2>
      <p className="max-w-[533px] text-left text-[16px]">
        Our automation feature is currently in beta mode. If you're looking to subscribe, we offer a monthly plan for
        <strong> $7</strong> with access to advanced automation tools. Click the corresponding button to express your
        interest, and our support team will get in touch via email.
      </p>
      <div className="flex items-center justify-end gap-2.5 mt-4">
        <Button type={ButtonType.BASIC} className="font-semibold" onClick={closeModal}>
          Cancel
        </Button>
        <Button type={ButtonType.FLAT} className="font-semibold" onClick={onSubmit}>
          Submit request
        </Button>
      </div>
    </div>
  );
}
